import {Flag} from 'platform/components';
import {Text, VStack} from 'platform/foundation';
import {match} from 'ts-pattern';

import type {ReactElement} from 'react';

import i18n from '@dms/i18n';

import {useAuctionCountdown} from '../../../hooks/useAuctionCountdown';
import {formatAuctionEndDate} from '../utils/formatAuctionEndDate';

interface AuctionCountdownCellProps {
  endTime: string;
}

export function AuctionCountdownCell(props: AuctionCountdownCellProps) {
  const countdown = useAuctionCountdown(props.endTime);
  const dateLabel = formatAuctionEndDate(props.endTime);
  const countdownContent = match<[boolean, boolean], ReactElement>([
    countdown.isEnded,
    countdown.isEndingSoon,
  ])
    .with([true, false], () => (
      <Flag label={i18n.t('entity.auction.status.ended')} colorScheme="neutral" size="small" />
    ))
    .with([false, true], () => (
      <Text size="xxSmall" color="warning" noWrap overflowWrap="anywhere">
        {i18n.t('entity.auction.status.endingSoon')}
      </Text>
    ))
    .otherwise(() => (
      <Text size="xxSmall" color="secondary" noWrap overflowWrap="anywhere">
        {countdown.label}
      </Text>
    ));

  return (
    <VStack spacing={1}>
      <Text size="xSmall" noWrap overflowWrap="anywhere">
        {dateLabel}
      </Text>
      {countdownContent}
    </VStack>
  );
}
